export default __webpack_public_path__ + "static/swim-14fcffe56f5645ee11a6597b136103d1.webp";